// @ts-nocheck
/** *****
 * Store Custom Code:
 * For updates, compare with: modules\content-library\src\Components\ProductImage.tsx
 * ****** */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { useState } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { dispatchProductClickEvent } from "@store/Services/AnalyticsService";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { focusStyles } from "@toolkit/Themes/common/mixins";

type ProductImageSize = "small" | "medium" | "large";
/* Store Custom Code - End */

interface OwnProps {
    product: CartLineModel | ProductContextModel | any; // Store Custom Code
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageStyles;
    showSmallImage?: boolean;
    // Store Custom Code
    overridedStyles?: ProductImageStyles;
    size?: ProductImageSize;
    analyticsId?: string;
}

type Props = OwnProps;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    // Store Custom Code
    wrapper?: InjectableCss;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            ${focusStyles()} /* Store Custom Code */
            width: 100%;
        `,
    },
    /* Store Removed Code - removed image */
    img: {
        css: css`
            height: auto;
            width: 100%;
        `,
    },
    /* Store Custom Code - Start */
    wrapper: {
        css: css`
            width: 100%;

            > span {
                cursor: default;
            }
        `,
    },
    /* Store Custom Code - End */
};

const ProductImage = ({
    product,
    onClick,
    extendedStyles,
    showSmallImage,
    // Store Custom Code
    overridedStyles,
    size = "small",
    analyticsId,
}: Props) => {
    const styles = useExpandProps(productImageStyles, extendedStyles, overridedStyles); // Store Custom Code

    let altText = "product" in product ? product.product.imageAltText : product.altText;
    if (!altText || altText === "") {
        altText = "product" in product ? product.product.productTitle : product.productName;
    }

    /* Store Custom Code - Start */
    const pathProperty = `${size}ImagePath`;
    const imagePath =
        "product" in product
            ? product.product.mediumImagePath || product.product.smallImagePath
            : product.smallImagePath || product.mediumImagePath;
    /* Store Custom Code - End */

    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";

    /* Store Custom Code - Start */
    const clickableCss = css`
        ${x => imageStyles(x.theme.design.product.image[size].ratio)}
        ${styles.linkWrappingImage?.css}
    `;

    const handleAnalyticsClick = () => {
        dispatchProductClickEvent(product, analyticsId);
    };
    /* Store Custom Code - End */

    return (
        <StyledWrapper {...styles.wrapper} /* Store Custom Code */>
            <Clickable
                {...styles.linkWrappingImage}
                href={productDetailPath}
                onClick={handleAnalyticsClick} // Store Custom Code
                data-test-selector="productImage"
                css={clickableCss} // Store Custom Code
            >
                {/* Store Custom Code - Start */}
                <Img {...styles.img} loading={loading} src={imagePath} altText={altText} />
                {/* Store Custom Code - End */}
            </Clickable>
        </StyledWrapper>
    );
};

export default ProductImage;
